<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: leftcolumn }">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Is Item?">
              <a-radio-group
                buttonStyle="solid"
                @change="handleis_item"
                :disabled="isItem"
                v-decorator="[
                  'is_item',
                  { rules: [{ required: true }], initialValue: 'yes' },
                ]"
              >
                <!-- , initialValue: initialData.informasi.inc_qc -->
                <a-radio-button value="yes">Yes</a-radio-button>
                <a-radio-button value="no">No</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-form-item label="Used For" v-if="trigered.used_for">
              <a-radio-group
                v-decorator="[
                  'used_for',
                  { rules: [{ required: true }], initialValue: '2' },
                ]"
                @change="handleUseFor"
              >
                <a-radio value="2">Tax</a-radio>
                <!-- <a-radio value="3">Shipping</a-radio> -->
                <a-radio value="4">Etc</a-radio>
                <a-radio value="1">Discount</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Tax Type" v-if="trigered.is_item == 'no' && trigered.tax">
          <a-select
            v-decorator="[
              'tax_type',
              {
                rules: [{ required: true }],
                initialValue: editData.values.tax_type,
              },
            ]"
            @change="taxTypeChange"
            showSearch
            option-filter-prop="children"
            :filter-option="filterOptionGeneral"
          >
            <a-select-option
                v-for="item in getType_tax"
                :key="item.value"
                :value="item.value"
              >
              {{item.text}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Tax Bearer Supplier?" v-if="trigered.is_item == 'no' && trigered.tax">
          <a-radio-group
            buttonStyle="solid"
            v-decorator="[
              'tax_bearer',
              { rules: [{ required: true }], initialValue: initialTaxBearer },
            ]"
            :disabled="trigered.disabledTaxBearer"
            @change="changeTaxBearer"
          >
            <a-radio-button value="1">Yes</a-radio-button>
            <a-radio-button value="0">No</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="PP Detail"
          v-if="
            this.trigered.is_item == 'yes' ||
            (this.trigered.is_item == 'no' && trigered.dis_tax_type)
          "
        >
          <a-select
            :disabled="trigered.disabledPPdtl"
            showSearch
            allowClear
            v-decorator="[
              'selectedPPdtl',
              { rules: [{ required: true }], initialValue: undefined },
            ]"
            option-filter-prop="children"
            :filter-option="filterOption"
          >
            <a-select-option v-for="item in ppdetillist" :key="item.id_pp_dtl">
              <div class="elipsdiv">
                <div class="elipsdiv-mouseover-label1" >
                  {{ item.nama_barang }} - {{ item.kode_anggaran }}</div>
                <div class="elipsdiv-mouseover-label2">
                    <b style="float: right">{{
                        formatCurrency(item.currency,parseFloat(item.nilai_dtl_pp))
                      }}
                    </b>
                </div>
              </div>
              <!-- <table style="width: 100%">
                <tr>
                  <td>
                    <span>
                      {{ item.nama_barang }} - {{ item.kode_anggaran }}</span
                    >
                  </td>
                  <td>
                    <b style="float: right"
                      >&nbsp;&nbsp;&nbsp;{{
                        formatCurrency(
                          item.currency,
                          parseFloat(item.nilai_dtl_pp)
                        )
                      }}
                    </b>
                  </td>
                </tr>
              </table> -->
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Name">
          <a-input
            autocomplete="off"
            v-decorator="['item_name', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="Option" v-if="trigered.cur">
              <a-select
                v-decorator="[
                  'cur_type',
                  { rules: [{ required: true }], initialValue: 'currency' },
                ]"
                @change="handleOption"
                :disabled="trigered.option"
              >
                <a-select-option value="currency">Nominal</a-select-option>
                <a-select-option value="percentage">Percentage</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="18">
            <a-form-item label="Value" v-if="trigered.cur">
              <a-input-number
                v-if="trigered.percentage == false"
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'harga',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
                @change="convertinghrg"
              />
              <a-input-number
                v-else
                type="number"
                :min="0"
                :max="100"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'harga',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
                @change="convertinghrg"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="Quantity" v-if="trigered.is_item == 'yes'">
              <a-input-number
                :min="0"
                :max="10000"
                class="m-width-full"
                v-decorator="[
                  'jumlah',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
                @change="convertingqty"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Unit" v-if="trigered.is_item == 'yes'">
              <a-auto-complete
                :dataSource="initialSatuan"
                placeholder="input here"
                v-decorator="['satuan', { rules: [{ required: true }] }]"
                :filterOption="handleSatuan"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Unit Price" v-if="trigered.is_item == 'yes'">
          <a-input-number
            :min="0"
            type="number"
            class="m-width-full m-text-align-right"
            @change="convertinghrg"
            :formatter="
              (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="[
              'harga',
              { rules: [{ required: true , message: 'Unit Price is required'}, { validator: checkPrice }] },
            ]"
          />
          <div v-if="mata_uang !== 'IDR'" class="m-form-description-small">Total value to IDR : {{convert_value}}</div>
        </a-form-item>
        <!-- <p v-if="mata_uang !== 'IDR'" class="margin-bottom">
          Total value to IDR: {{ convert_value }}<br />
        </p> -->
        <a-form-item label="Note" v-if="trigered.is_item == 'yes'">
          <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="[
              'catatan_dtl',
              { rules: [{ required: false, message: 'Note is required' }] },
            ]"
          />
        </a-form-item>
        <a-divider class="margin-bottom-small">or</a-divider>
        <a-form :form="formUpload">
          <a-form-item>
            <h4>Upload Excel File</h4>
            <p>
              If You Don't Have a File Upload Template Please Click
              <a-button
                class="padding-remove"
                type="link"
                @click="handleDownload"
                >Download Template</a-button
              >
            </p>
            <a-upload
              accept=".xls, .xlsx"
              :showUploadList="true"
              :fileList="push"
              v-decorator="['file_transfer']"
              :remove="handleRemoveList"
              :beforeUpload="beforeUpload"
            >
              <a-button :disabled="trigered.is_item == 'no'">
                <a-icon type="upload" />&nbsp;Select File
              </a-button>
            </a-upload>
            <a-divider v-if="getScreen"></a-divider>
          </a-form-item>
        </a-form>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleNewItem"
            :loading="newLoading"
            block
            type="primary"
            html-type="submit"
            >Add</a-button
          >
        </a-form-item>
      </a-col>

      <a-col :xs="{ span: 24 }" :lg="{ span: rightcolumn }">
        <a-card class="m-height-full m-display-flex nowrap flex-column">
          <div slot="title">
            <span>Work List</span>
          </div>
          <template slot="extra">
            <a-button
              :loading="collectiveLoading"
              @click="onCollective"
              class="margin-right-small"
              icon="edit"
              >Collective</a-button
            >
            <a-button @click="handleExpand">
              <span>{{ labelExpand }}</span>
            </a-button>
          </template>
          <a-table
            v-if="!getScreen"
            :columns="columns"
            :dataSource="getCountWeb"
            :pagination="pagination"
            size="small"
            :scroll="{ x: 700 }"
            bordered
          >
            <span slot="item_name" slot-scope="item_name">
              {{ item_name.item_name }}<br />
              <b>{{ item_name.pp_nama_barang }}</b
              ><br />
              <i>{{ item_name.pp_kode_anggaran }}</i>
            </span>
            <div slot="itemPPDtl" slot-scope="item">
              <h4 class="margin-remove">{{ item.deskripsi }}</h4>
              <small
                >{{ item.pp_nama_barang }}
                {{
                  item.pp_kode_anggaran ? " | " + item.pp_kode_anggaran : ""
                }}</small
              >
              <a-alert
                type="error"
                banner
                v-if="
                  item.pp_kode_anggaran == null || item.pp_kode_anggaran == ''
                "
                message="item anggaran cannot be empty"
              />
            </div>
            <span slot="unit_price" slot-scope="unit_price">
              <CurrencyJustified
                v-if="unit_price.val"
                :currencyValue="unit_price.curr"
                :valueNumber="unit_price.val"
              />
              <div v-else style="text-align: center; width: 100%">-</div>
            </span>
            <span slot="amount" slot-scope="amount">
              <CurrencyJustified
                v-if="amount.val"
                :currencyValue="amount.curr"
                :valueNumber="amount.val"
              />
              <div v-else style="text-align: center; width: 100%">-</div>
            </span>
            <span slot="note" slot-scope="note">
             {{note ? note.values.catatan_dtl : ''}}
            </span>
            <template slot="operation" slot-scope="index, item">
              <a-button-group v-if="item">
                <a-button
                  type="primary"
                  :disabled="totalDiscList > 0"
                  @click="handleEditModal(item)"
                >
                  <a-icon type="edit" />
                </a-button>
                <a-button type="danger" @click="handleRemove(item.values)">
                  <a-icon type="close" />
                </a-button>
              </a-button-group>
            </template>
          </a-table>
          <a-list
            v-else
            itemLayout="vertical"
            :dataSource="listWO"
            :pagination="pagination"
          >
            <Empty v-if="listWO ? listWO.length <= 0 : listWO" />
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <span slot="title">
                  {{ item.values.item_name }} <br />
                  <div slot="itemPPDtl" slot-scope="item">
                    <small
                      >{{ item.pp_nama_barang }}
                      {{
                        item.pp_kode_anggaran
                          ? " | " + item.pp_kode_anggaran
                          : ""
                      }}</small
                    >
                    <a-alert
                      type="error"
                      banner
                      v-if="
                        item.pp_kode_anggaran == null ||
                        item.pp_kode_anggaran == ''
                      "
                      message="item anggaran cannot be empty"
                    />
                  </div>
                </span>
                <div slot="description" class="margin-remove">
                  <div class="m-display-flex space-between">
                    <span
                      >{{ item.values.jumlah }}&nbsp;{{
                        item.values.satuan
                      }}</span
                    >
                    <div>
                      <h4 class="margin-remove m-text-align right">
                        @ {{ formatCurrency(mata_uang, item.values.harga) }}
                      </h4>
                    </div>
                  </div>
                  <a-divider class="margin-small" />
                  <h4 class="margin-remove m-text-align right">
                    {{ formatCurrency(mata_uang, item.values.hargaTotal) }}
                  </h4>
                </div>
              </a-list-item-meta>
              <a-button-group>
                <a-button @click="handleEditModal(item)" type="primary">
                  <a-icon type="edit" />&nbsp;Edit
                </a-button>
                <a-button
                  @click="handleRemove(item.values)"
                  type="danger"
                  class="m-text-danger"
                >
                  <a-icon type="close" />&nbsp;Remove
                </a-button>
              </a-button-group>
            </a-list-item>
          </a-list>
        </a-card>

        <div class="m-price-total" style="margin-bottom:0px!important">
          <div class="footer-list">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
                <h3 class="margin-remove m-text-align right">Sub Total :</h3>
              </a-col>
              <a-col :span="9">
                <h3 class="m-text-align">
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="totalPrice"
                  />
                </h3>
              </a-col>
            </a-row>
          </div>
          <a-divider class="margin-medium" />
          <div v-for="item in getListDisc" :key="item.key" class="footer-list">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <span
                  v-if="item.values.cur_type !== 'percentage'"
                  class="m-text-align footer-list footer-light"
                >
                  {{ item.item_name }} :
                </span>
                <span v-else class="m-text-align footer-list footer-light">
                  {{ item.item_name }} ({{ item.values.harga + "%" }}) :
                </span>
              </a-col>
              <a-col :span="3">
                <a-button-group class="m-text-align right footer-list">
                  <a-button
                    type="primary"
                    size="small"
                    @click="handleEditModal(item)"
                  >
                    <a-icon type="edit" />
                  </a-button>
                  <a-button
                    type="danger"
                    size="small"
                    @click="handleRemove(item.values)"
                  >
                    <a-icon type="close" />
                  </a-button>
                </a-button-group>
              </a-col>
              <a-col :span="9">
                <span
                  class="m-text-align footer-light"
                  :style="item.unit_price < 0 ? 'color:red' : 'color:black'"
                  v-if="item.values.cur_type !== 'percentage'"
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="item.unit_price"
                  />
                </span>
                <span
                  class="m-text-align footer-light"
                  :style="
                    (totalPrice * item.values.harga) / 100 < 0
                      ? 'color:red'
                      : 'color:black'
                  "
                  v-else
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="(totalPrice * item.values.harga) / 100"
                  />
                </span>
              </a-col>
            </a-row>
          </div>
          <div class="footer-list">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
                <h3 class="margin-remove m-text-align right">
                  Total Discount :
                </h3>
              </a-col>
              <a-col :span="9">
                <h3 class="m-text-align">
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="totalDiscList"
                  />
                </h3>
              </a-col>
            </a-row>
          </div>
          <a-divider class="margin-medium" />
          <div v-for="item in getListTax" :key="item.key" class="footer-list">
            <a-row :gutter="8" style="padding-top:5px!important">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <span
                  v-if="item.values.cur_type !== 'percentage'"
                  class="m-text-align footer-list footer-light" style="padding-right: 15px!important;"
                >
                  {{toTextTax(item)}} > {{ item.item_name }} :
                </span>
                <span v-else class="m-text-align footer-list footer-light">
                  {{toTextTax(item)}} > {{ item.item_name }} ({{ item.values.harga + "%" }}) :
                </span>
                <span class="m-text-align" style="float:right;padding-right: 15px!important;"
                  v-if="item.values.used_for=='2' && item.values.tax_type"><b><i><small>({{ item.values.tax_bearer=='0' ? 'Tax bearer : INFOGLOBAL' : 'Tax bearer : SUPPLIER' }})</small></i></b>
                </span>
              </a-col>
              <a-col :span="3">
                <a-button-group
                  class="m-text-align right footer-list footer-light"
                >
                  <a-button
                    type="primary"
                    size="small"
                    @click="handleEditModal(item)"
                  >
                    <a-icon type="edit" />
                  </a-button>
                  <a-button
                    type="danger"
                    size="small"
                    @click="handleRemove(item.values)"
                  >
                    <a-icon type="close" />
                  </a-button>
                </a-button-group>
              </a-col>
              <a-col :span="9">
                <span
                  class="m-text-align footer-light"
                  :style="item.unit_price < 0 ? 'color:red' : 'color:black'"
                  v-if="item.values.cur_type !== 'percentage'"
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="item.unit_price"
                  />
                </span>
                <span
                  class="m-text-align footer-light"
                  :style="
                    ((totalPrice - totalDiscList) * item.values.harga) / 100 < 0
                      ? 'color:red'
                      : 'color:black'
                  "
                  v-else
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="((totalPrice - totalDiscList) * item.values.harga) / 100"
                  />
                </span>
              </a-col>
            </a-row>
          </div>
          <div class="footer-list">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
                <h3 class="margin-remove m-text-align right">Total Tax :</h3>
              </a-col>
              <a-col :span="9">
                <h3 class="m-text-align">
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="nilaiPajak"
                  />
                </h3>
              </a-col>
            </a-row>
          </div>
          <a-divider class="margin-medium" />
          <div
            v-for="item in getListUsualShipp"
            :key="item.key"
            class="footer-list footer-light"
          >
            <a-row :gutter="8" style="padding-top:5px!important">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <span
                  v-if="item.values.cur_type !== 'percentage'"
                  class="m-text-align footer-list footer-light"
                >
                  {{ item.item_name }} :
                </span>
                <span v-else class="m-text-align footer-list footer-light">
                  {{ item.item_name }} ({{ item.values.harga + "%" }}) :
                </span>
              </a-col>
              <a-col :span="3">
                <a-button-group
                  class="m-text-align right footer-list footer-light"
                >
                  <a-button
                    type="primary"
                    size="small"
                    @click="handleEditModal(item)"
                  >
                    <a-icon type="edit" />
                  </a-button>
                  <a-button
                    type="danger"
                    size="small"
                    @click="handleRemove(item.values)"
                  >
                    <a-icon type="close" />
                  </a-button>
                </a-button-group>
              </a-col>
              <a-col :span="9">
                <span
                  class="m-text-align footer-light"
                  :style="item.unit_price < 0 ? 'color:red' : 'color:black'"
                  v-if="item.values.cur_type !== 'percentage'"
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="item.unit_price"
                  />
                </span>
                <span
                  class="m-text-align footer-light"
                  :style="
                    (totalPrice * item.values.harga) / 100 < 0
                      ? 'color:red'
                      : 'color:black'
                  "
                  v-else
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="(totalPrice * item.values.harga) / 100"
                  />
                </span>
              </a-col>
            </a-row>
          </div>
          <a-statistic
            title="Total Bill"
            :value="formatCurrency(mata_uang, grandTotal)"
            class="margin-top m-text-align right"
          />
        </div>
        <i v-if="anyPPH" style="color:red">* PPh is not calculated </i>
      </a-col>
    </a-row>

    <a-modal
      v-model="editModal"
      :key="editData.values.item_name"
      :footer="null"
      @cancel="handleClose"
      :maskClosable="false"
    >
      <span slot="title"> <a-icon type="form" />&nbsp;Change Work </span>

      <a-form :form="modalForm">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Is Item?">
              <a-radio-group
                buttonStyle="solid"
                @change="handleis_item"
                :disabled="true"
                v-decorator="[
                  'is_item',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.values.is_item,
                  },
                ]"
              >
                <!-- , initialValue: initialData.informasi.inc_qc -->
                <a-radio-button value="yes">Yes</a-radio-button>
                <a-radio-button value="no">No</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-form-item label="Used For" v-if="trigered.is_item == 'no'">
              <a-radio-group
                :disabled="true"
                v-decorator="[
                  'used_for',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.values.used_for,
                  },
                ]"
                @change="handleUseFor"
              >
                <a-radio value="2">Tax</a-radio>
                <!-- <a-radio value="3">Shipping</a-radio> -->
                <a-radio value="4">Etc</a-radio>
                <a-radio value="1">Discount</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Tax Type" v-if="trigered.is_item == 'no' && trigered.tax">
          <a-select
            v-decorator="[
              'tax_type',
              {
                rules: [{ required: true }],
                initialValue: editData.values.tax_type,
              },
            ]"
            disabled
            showSearch
            option-filter-prop="children"
            :filter-option="filterOptionGeneral"
          >
            <a-select-option
                v-for="item in getType_tax"
                :key="item.value"
                :value="item.value"
              >
              {{item.text}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Tax Bearer Supplier?" v-if="trigered.is_item == 'no' && trigered.tax">
          <a-radio-group
            buttonStyle="solid"
            v-decorator="[
              'tax_bearer',
              { rules: [{ required: true }], initialValue: editData.values.tax_bearer },
            ]"
            :disabled="true"
            @change="changeTaxBearer"
          >
            <a-radio-button value="1">Yes</a-radio-button>
            <a-radio-button value="0">No</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="PP Detail"
          v-if="
            this.trigered.is_item == 'yes' ||
            (this.trigered.is_item == 'no' && trigered.dis_tax_type)
          "
        >
          <a-select
            showSearch
            allowClear
            v-decorator="[
              'selectedPPdtl',
              {
                rules: [{ required: true }],
                initialValue: editData.values.selectedPPdtl,
              },
            ]"
            option-filter-prop="children"
            :filter-option="filterOption"
            :disabled="true"
          >
            <a-select-option
              v-for="item in ppdetillist"
              :key="item.id_pp_dtl"
              :value="item.id_pp_dtl"
            >
              <table style="width: 100%">
                <tr>
                  <td>
                    <span>
                      {{ item.nama_barang }} - {{ item.kode_anggaran }}</span
                    >
                  </td>
                  <td>
                    <b style="float: right"
                      >&nbsp;&nbsp;&nbsp;{{
                        formatCurrency(
                          item.currency,
                          parseFloat(item.nilai_dtl_pp)
                        )
                      }}
                    </b>
                  </td>
                </tr>
              </table>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Name">
          <a-input
            autocomplete="off"
            v-decorator="[
              'item_name',
              {
                rules: [{ required: true }],
                initialValue: editData.values.item_name,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-row :gutter="8" v-if="trigered.is_item == 'yes'">
          <a-col :span="12">
            <a-form-item label="Quantity">
              <a-input-number
                :min="1"
                :max="10000"
                class="m-width-full"
                v-decorator="[
                  'jumlah',
                  {
                    rules: [{ required: true }, { validator: checkPrice }],
                    initialValue: editData.values.jumlah,
                  },
                ]"
                @change="convertingmodalqty"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Unit">
              <a-auto-complete
                :dataSource="initialSatuan"
                placeholder="input here"
                v-decorator="[
                  'satuan',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.values.satuan,
                  },
                ]"
                :filterOption="handleSatuan"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="Option" v-if="trigered.is_item == 'no'">
              <a-select
                v-decorator="[
                  'cur_type',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.values.cur_type,
                  },
                ]"
                @change="handleOptionmodal"
                :disabled="trigered.option"
              >
                <a-select-option value="currency">Nominal</a-select-option>
                <a-select-option value="percentage">Percentage</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Value" v-if="trigered.is_item == 'no'">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'harga',
                  {
                    rules: [{ required: true }, { validator: checkPrice }],
                    initialValue: parseFloat(editData.values.harga),
                  },
                ]"
                @change="convertingmodalhrg"
                v-on:keydown.enter.prevent="preventEnterButtonModal"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Unit Price" v-if="trigered.is_item == 'yes'">
          <a-input-number
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="
              (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="[
              'harga',
              {
                rules: [{ required: true }, { validator: checkPrice }],
                initialValue: editData.values.harga,
              },
            ]"
            @change="convertingmodalhrg"
          />
          <div v-if="mata_uang !== 'IDR'" class="m-form-description-small">Total value to IDR : {{modalconvert_value}}</div>
        </a-form-item>
        <!-- <p v-if="mata_uang !== 'IDR'" class="margin-bottom">
          Total value to IDR: {{ modalconvert_value }}<br />
        </p> -->
        <a-form-item label="Note" v-if="trigered.is_item == 'yes'">
          <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="[
              'catatan_dtl',
              { rules: [{ required: false, message: 'Note is required' }], initialValue: editData.values.catatan_dtl, },
            ]"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleModalEdit(editData.key)"
            block
            type="danger"
            html-type="submit"
            >Change</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>

    <Collective
      v-if="isCollective"
      :close="handleCloseCollective"
      :datasource="listWO"
    >
      <div slot="title"><a-icon type="edit" />&nbsp;Edit Collective</div>
      <template slot="content">
        <a-form class="margin-bottom" :form="formCollective">
          <a-form-item label="PP Detail">
            <a-select
              showSearch
              class="select-between"
              placeholder="Select PP"
              option-filter-prop="children"
              :filter-option="filterOption"
              v-decorator="[
                'kode_anggaran',
                {
                  rules: [{ required: true }],
                },
              ]"
            >
              <a-select-option
                v-for="item in ppdetillist"
                :key="item.id_pp_dtl"
                :disabled="item.nilai_dtl_pp == '0' ? true : false"
              >
                <div class="option-between">
                  <div class="option-between__left">
                    <b>{{ item.nama_barang }}</b>
                    <small> | </small>
                    <small>{{ item.kode_anggaran }}</small>
                  </div>
                  <div class="option-between__right">
                    <small>
                      {{
                        formatCurrency(
                          item.currency,
                          item.nilai_dtl_pp
                        ).replace(",00", "")
                      }}
                    </small>
                  </div>
                </div>

                <!-- <div class="select-option">
                  <div v-if="!getScreen">
                    <h4>{{ item.nama_barang }}</h4>
                    <small>|</small>
                    <small>{{ item.kode_anggaran }}</small>
                  </div>
                  <h4 v-else>{{ item.nama_barang }}</h4>
                  <small>
                    {{
                    formatCurrency(item.currency,item.nilai_dtl_pp)
                    .replace(",00", "")
                    }}
                  </small>
                </div> -->
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
        <a-table
          :columns="columns"
          :dataSource="mlistWO"
          :pagination="false"
          size="small"
          :scroll="{ x: 610 }"
          :loading="loadingTable"
          bordered
        >
          <div slot="itemPPDtl" slot-scope="item">
            <h4 class="margin-remove">{{ item.deskripsi }}</h4>
            <small
              >{{ item.pp_nama_barang }}
              {{
                item.pp_kode_anggaran ? " | " + item.pp_kode_anggaran : ""
              }}</small
            >
            <a-alert
              type="error"
              banner
              v-if="
                item.pp_kode_anggaran == null || item.pp_kode_anggaran == ''
              "
              message="item anggaran cannot be empty"
            />
          </div>
          <span slot="item_name" slot-scope="item_name">
            {{ item_name.item_name }}<br />
            <b>{{ item_name.pp_nama_barang }}</b
            ><br />
            <i>{{ item_name.pp_kode_anggaran }}</i>
          </span>
          <span slot="unit_price" slot-scope="unit_price">
            <CurrencyJustified
              v-if="unit_price.val"
              :currencyValue="unit_price.curr"
              :valueNumber="unit_price.val"
            />
            <div v-else style="text-align: center; width: 100%">-</div>
          </span>
          <span slot="amount" slot-scope="amount">
            <CurrencyJustified
              v-if="amount.val"
              :currencyValue="amount.curr"
              :valueNumber="amount.val"
            />
            <div v-else style="text-align: center; width: 100%">-</div>
          </span>
          <span slot="note" slot-scope="note">
            {{note ? note.values.catatan_dtl : ''}}
          </span>
          <template slot="operation" slot-scope="index, item">
            <a-checkbox
              :checked="
                selected.filter((obj) => obj.key == item.key).length == 0
                  ? false
                  : true
              "
              @change="handleCheck"
              :value="item"
            />
          </template>
        </a-table>
      </template>
      <template slot="resume">
        <h3>
          Sub Total :
          {{
            formatCurrency(this.mata_uang, this.totalSelected).replace(
              ",00",
              ""
            )
          }}
        </h3>
      </template>
      <a-button-group slot="action">
        <a-button
          @click="handleSet"
          type="primary"
          :disabled="selected.length == 0"
          >Set</a-button
        >
        <a-button
          @click="handleCloseCollective"
          :type="selected.length == 0 ? 'primary' : ''"
          >Done</a-button
        >
      </a-button-group>
    </Collective>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import axios from "axios";
import _ from "lodash";
import Collective from "@/components/collective/Collective.vue";
import CollectiveWO from "@/mixins/collective/collectiveWO";

export default {
  name: "DetailWO",
  mixins: [CurrencyFormat, CollectiveWO],
  props: {
    data: {},
    listWO: {},
    mode: String,
    mata_uang: String,
    kurs: String,
  },
  components: {
    Collective,
  },
  data() {
    return {
      editModal: false,
      editData: {
        values: {
          id_wo_dtl: "",
          item_name: "",
          jumlah: 0,
          satuan: "",
          harga: 0,
          hargaTotal: 0,
        },
      },
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      satuan: [],
      form: this.$form.createForm(this),
      push: [],
      newLoading: false,
      ppdetillist: [],
      trigered: {
        used_for: false,
        pn: true,
        cur: false,
        qty_unit: true,
        is_item: "yes",
        percentage: false,
        disc: false,
        disabledPPdtl: false,
        tax: false,
        dis_tax_type: false,
        disabledTaxBearer: true,
        enablePPTaxBearer:false,
        option:false,
      },
      isItem: true,
      convert_value: 0,
      modalconvert_value: 0,
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      loadingTable: false,
      trigEmptyList: false,
      initialTaxBearer: "1",
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
    this.formUpload = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getScreen", "getSatuan", "getAuth","getType_tax"]),
    initialData() {
      if (this.listWO === undefined || this.listWO.length <= 0) {
        return {
          id_wo_dtl: "",
          item_name: "",
          jumlah: 0,
          satuan: "",
          harga: 0,
          hargaTotal: 0,
        };
      } else {
        return {
          id_wo_dtl: this.listWO.id_wo_dtl,
          item_name: this.listWO.item_name,
          jumlah: this.listWO.jumlah,
          satuan: this.listWO.satuan,
          harga: this.listWO.harga,
          hargaTotal: this.listWO.hargaTotal,
        };
      }
    },
    initialList() {
      let outputList = [];
      if (this.listWO.length >= 1) {
        outputList = this.listWO;
      }

      return outputList;
    },
    initialSatuan() {
      let satuan = [];
      this.getSatuan.forEach((item) => {
        satuan.push(item["id"]);
      });

      return satuan;
    },
    totalSelected() {
      let total = this.selected.reduce(
        (sum, item) => sum + item.values.hargaTotal,
        0
      );
      return total;
    },
    totalPrice() {
      let total = 0;
      this.getCountWeb.forEach((item) => {
        total = total + item.values.hargaTotal;
      });

      return total;
    },
    totalPriceList() {
      let total = 0;
      this.getCountList.forEach((item) => {
        if (item.values.used_for == "4") {
          total = total + item.values.hargaTotal;
        }
      });

      return total;
    },
    totalDiscList() {
      let total = 0;
      this.getCountList.forEach((item) => {
        if (item.values.used_for == "1") {
          total = total + item.values.hargaTotal;
          //console.log("totalDiscList", total, item.values.hargaTotal);
        }
      });

      return total;
    },
    totalShipping() {
      let shipping = 0;
      this.getCountList.forEach((item) => {
        if (item.values.used_for == "3") {
          shipping = shipping + item.values.hargaTotal;
        }
      });
      return shipping;
    },
    grandTotal() {
      return (
        this.totalPrice +
        this.totalPriceList +
        this.nilaiPajak +
        (this.totalShipping > 0 ? parseFloat(this.totalShipping) : 0) -
        this.totalDiscList
      );
    },
    nilaiPajak() {
      let tax = 0;
      this.getCountList.forEach((item) => {
        if(!(item.values.tax_type && item.values.tax_type.includes('pph'))){
          if (item.values.used_for == "2") {
            if (item.values.cur_type == "percentage") {
              tax =
                tax +
                (parseFloat(item.values.harga) *
                  (this.totalPrice - this.totalDiscList)) /
                  100;
            } else {
              tax = tax +  
                parseFloat(item.values.harga);
            }
          }
        }
      });
      return tax;
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          sorter: (a, b) => a.no - b.no,
          fixed: "left",
        },
        {
          title: "Work Name",
          // dataIndex: "item_name",
          width: 200,
          key: "item_name",
          scopedSlots: { customRender: "item_name" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "PP Detail",
          width: 250,
          scopedSlots: { customRender: "itemPPDtl" },
          sorter: (a, b) => a.pp_nama_barang.length - b.pp_nama_barang.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },

        {
          title: "Unit Price",
          dataIndex: "unit_price",
          key: "unit_price",
          width: 100,
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: "Amount",
          dataIndex: "amount",
          key: "amount",
          width: 100,
          scopedSlots: { customRender: "amount" },
        },
        {
          title: "Note",
          key: "note",
          width: 150,
          scopedSlots: { customRender: "note" },
        },
        {
          title: this.isCollective ? "Check" : "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 110,
          fixed: "right",
        },
      ];
      return kolom;
    },
    getCountWeb() {
      let data = this.listWO.filter((item) => item.values.is_item == "yes");
      if (data) {
        this.isItem = true;
        if (data.length > 0) {
          this.isItem = false;
        }
        data.forEach((value, index) => {
          data[index]["item_name"] = value.values.item_name;
          data[index]["amount"] = {
            curr: this.mata_uang,
            val: Number(value.values.hargaTotal),
          };
          data[index]["quantity"] =
            value.values.jumlah + " " + value.values.satuan;
          data[index]["unit_price"] = {
            curr: this.mata_uang,
            val: Number(value.values.harga),
          };
          data[index]["total_val"] =
            parseFloat(value.values.jumlah) * parseFloat(value.values.harga);
          data[index]["no"] = index + 1;
          data[index]["key"] = "a" + (index + 1);
          data[index]["pp_kode_anggaran"] = data[index]["pp_kode_anggaran"]
            ? data[index]["pp_kode_anggaran"]
            : value.values.pp_kode_anggaran
            ? value.values.pp_kode_anggaran
            : "";
          data[index]["pp_nama_barang"] = data[index]["pp_nama_barang"]
            ? data[index]["pp_nama_barang"]
            : value.values.pp_nama_barang
            ? value.values.pp_nama_barang
            : "";
          data[index]["is_item"] = value.values.is_item;
          data[index]["selectedPPdtl"] = data[index]["selectedPPdtl"]
            ? data[index]["selectedPPdtl"]
            : value.values.selectedPPdtl
            ? value.values.selectedPPdtl
            : "";
        });
      }
      return data;
    },
    getCountList() {
      let data = this.listWO.filter((item) => item.values.is_item == "no");
      if (data) {
        data.forEach((value, index) => {
          data[index]["is_item"] = value.values.is_item;
          data[index]["item_name"] = value.values.item_name;
          data[index]["unit_price"] = value.values.harga;
          data[index]["key"] =
            (value.values.used_for == "1" ? "bdisc" : "list") + (index + 1);
          data[index]["selectedPPdtl"] = value.values.selectedPPdtl;
        });
      }
      return data;
    },
    getListTax() {
      let data = this.listWO.filter(
        (item) => item.values.is_item == "no" && item.values.used_for == "2"
      );
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] = value.values.item_name;
          data[index]["unit_price"] = value.values.harga;
          data[index]["key"] = "tax" + (index + 1);
          data[index]["selectedPPdtl"] = value.values.selectedPPdtl;
        });
      }
      return data;
    },
    getListDisc() {
      let data = this.listWO.filter(
        (item) => item.values.is_item == "no" && item.values.used_for == "1"
      );
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] = value.values.item_name;
          data[index]["unit_price"] = value.values.harga;
          data[index]["key"] = "disc" + (index + 1);
          data[index]["selectedPPdtl"] = value.values.selectedPPdtl;
        });
      }
      return data;
    },
    getListUsualShipp() {
      let data = this.listWO.filter(
        (item) =>
          item.values.is_item == "no" &&
          (item.values.used_for == "3" || item.values.used_for == "4")
      );
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] = value.values.item_name;
          data[index]["unit_price"] = value.values.harga;
          data[index]["key"] = "usualship" + (index + 1);
          data[index]["selectedPPdtl"] = value.values.selectedPPdtl;
        });
      }
      return data;
    },
    anyPPH() {
      let r = _.filter(this.listWO, (item) => item.values.tax_type && item.values.tax_type.indexOf("pph") >= 0);
      return r.length > 0
    }
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("responseConfirmAdd", this.confirmAdd);
    this.resetForm();
  },
  activated() {
    this.resetForm();
    this.fetchAttribute();
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("responseConfirmAdd", this.confirmAdd);
  },
  methods: {
    handleExpand() {
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
        //this.pagination.pageSize = 10;
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
        //this.pagination.pageSize = 5;
      }
    },
    convertingqty(val) {
      let vinput = this.form.getFieldsValue();
      let tot =
        (val ? val : vinput.jumlah) * vinput.harga * parseFloat(this.kurs);
      this.convert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    convertinghrg(val) {
      let vinput = this.form.getFieldsValue();
      let tot =
        (vinput.jumlah ? vinput.jumlah : 1) *
        (val ? val : vinput.harga) *
        parseFloat(this.kurs);

      if (vinput.is_item == "no") {
        if (vinput.cur_type == "percentage") {
          if (vinput.used_for == "3" || vinput.used_for == "4") {
            tot = ((this.totalPrice * val) / 100) * parseFloat(this.kurs);
          } else {
            tot =
              (((this.totalPrice - this.totalDiscList) * val) / 100) *
              parseFloat(this.kurs);
          }
        }
      }
      this.convert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    convertingmodalqty(val) {
      let vinput = this.modalForm.getFieldsValue();
      let tot =
        (val ? val : vinput.jumlah) * vinput.harga * parseFloat(this.kurs);
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    convertingmodalhrg(val) {
      let vinput = this.modalForm.getFieldsValue();
      let tot =
        vinput.jumlah * (val ? val : vinput.harga) * parseFloat(this.kurs);

      if (vinput.is_item == "no") {
        if (vinput.cur_type == "percentage") {
          if (vinput.used_for == "3" || vinput.used_for == "4") {
            tot = ((this.totalPrice * val) / 100) * parseFloat(this.kurs);
          } else {
            let tdisc = vinput.used_for == "1" ? 0 : this.totalDiscList;
            tot =
              (((this.totalPrice - tdisc) * val) / 100) * parseFloat(this.kurs);
          }
        }
      }
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    simulasiEditDiskon(valedit, val) {
      //validasi apabila dicount berubah dari percentage ke currency dan sebaliknya
      let result = true;
      if (val.used_for == "1") {
        //console.log("trig", valedit, val, this.getCountWeb);
        for (let index = 0; index < this.ppdetillist.length; index++) {
          this.ppdetillist[index].temp_remove_val =
            this.ppdetillist[index].nilai_dtl_pp;
        }

        //simulasi diskon dihapus untuk menghitung diskon yang baru
        this.getCountWeb.forEach((ment) => {
          let ppdtl = ment.values.selectedPPdtl;
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem == ppdtl) {
              let bsaran =
                (valedit.values.hargaTotal / this.totalPrice) *
                (valedit.cur_type == "percentage"
                  ? (valedit.values.harga * this.totalPrice) / 100
                  : valedit.values.harga);
              // console.log(
              //   "pertama-",
              //   valedit.values.hargaTotal,
              //   this.totalPrice,
              //   val.cur_type == "percentage"
              //     ? (valedit.values.harga * this.totalPrice) / 100
              //     : valedit.values.harga
              // );
              // console.log(
              //   this.ppdetillist[index].temp_remove_val,
              //   bsaran,
              //   this.ppdetillist[index].temp_remove_val - bsaran
              // );
              this.ppdetillist[index].temp_remove_val =
                this.ppdetillist[index].temp_remove_val - bsaran;
              if (this.ppdetillist[index].temp_remove_val < 0) {
                result = false;
              }
            }
          }
        });
        //console.log("this.ppdetillist", this.ppdetillist);

        //simulasi diskon yang baru
        this.getCountWeb.forEach((ment) => {
          let ppdtl = ment.values.selectedPPdtl;
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem == ppdtl) {
              //console.log("jos ndak");
              let bsaran =
                (ment.values.hargaTotal / this.totalPrice) *
                (val.cur_type == "percentage"
                  ? (val.harga * this.totalPrice) / 100
                  : val.harga);
              // console.log(
              //   "-",
              //   this.totalPrice,
              //   val.cur_type == "percentage"
              //     ? (val.harga * this.totalPrice) / 100
              //     : val.harga
              // );
              // console.log(
              //   this.ppdetillist[index].temp_remove_val,
              //   bsaran,
              //   this.ppdetillist[index].temp_remove_val - bsaran
              // );
              this.ppdetillist[index].temp_remove_val =
                this.ppdetillist[index].temp_remove_val + bsaran;
              if (this.ppdetillist[index].temp_remove_val < 0) {
                result = false;
              }
            }
          }
        });
      }
      return result;
    },
    resetForm() {
      this.form.resetFields();
      this.isItem = true;
      this.trigered.cur = false;
      this.trigered.disc = false;
      this.trigered.is_item = "yes";
      this.trigered.percentage = false;
      this.trigered.pn = true;
      this.trigered.qty_unit = true;
      this.trigered.used_for = false;
      this.trigered.dis_tax_type = false;
      this.trigered.option = false;
      this.initialTaxBearer = "0";
    },
    isObject(obj) {
      return obj === Object(obj);
    },
    simulation(arr, poin, mode) {
      let result = true;
      if (this.ppdetillist.length > 0) {
        for (let index = 0; index < this.ppdetillist.length; index++) {
          this.ppdetillist[index].temp_nilai_dtl_pp =
            this.ppdetillist[index].nilai_dtl_pp_origin;
        }
      }

      //short a to z
      arr.sort(function (a, b) {
        var x = a.key;
        var y = b.key;
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });

      if (arr.length > 0) {
        //menghitung total jumlah item terbaru
        let totalprice = 0;
        arr.forEach((ent) => {
          if (ent.values.is_item == "yes") {
            totalprice += parseFloat(ent.values.hargaTotal);
          }
        });
        //menghitung diskon terbaru
        let totaldisc = 0;
        arr.forEach((ent) => {
          if (ent.values.is_item == "no" && ent.values.used_for == "1") {
            totaldisc +=
              ent.values.cur_type == "currency"
                ? parseFloat(ent.values.hargaTotal)
                : (parseFloat(ent.values.harga) * totalprice) / 100;
          }
          // if (ent.values.is_item == "no" && (ent.values.tax_type && ent.values.tax_type.includes("pph"))) {
          //   totaldisc +=
          //     ent.values.cur_type == "currency"
          //       ? parseFloat(ent.values.hargaTotal)
          //       : (parseFloat(ent.values.harga) * totalprice) / 100;
          // }
        });
        let totalpricedisc = totalprice - totaldisc;
        //short a to z
        arr.sort(function (a, b) {
          var x = a.key;
          var y = b.key;
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
        //console.log("short", arr);
        arr.forEach((ment) => {
          let ppdtl = ment.values.selectedPPdtl;
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem == ppdtl) {
              if (ment.values.cur_type == "percentage") {
                let hitung1 =
                  // (parseFloat(ment.values.harga) *
                  //   (ment.values.used_for == "2" && !(ment.values.tax_type && ment.values.tax_type.includes("pph"))
                   (parseFloat(ment.values.harga) *
                    (ment.values.used_for == "2"
                      ? totalpricedisc
                      : totalprice)) /
                  100;
                this.ppdetillist[index].temp_nilai_dtl_pp = (
                  parseFloat(this.ppdetillist[index].temp_nilai_dtl_pp) -
                  hitung1
                ).toString();
                // console.log(
                //   ment.key,
                //   index,
                //   "%kurangi",
                //   ment.values.pp_nama_barang,
                //   hitung1,
                //   this.ppdetillist[index].temp_nilai_dtl_pp,
                //   parseFloat(ment.values.harga),
                //   mode,
                //   totalpricedisc,
                //   "=",
                //   totalprice,
                //   this.totalDiscList
                // );
              } else {
                let hitung2 = parseFloat(ment.values.hargaTotal);
                this.ppdetillist[index].temp_nilai_dtl_pp = (
                  parseFloat(this.ppdetillist[index].temp_nilai_dtl_pp) -
                  hitung2
                ).toString();
                // console.log(
                //   ment.key,
                //   index,
                //   "kurangi",
                //   ment.values.pp_nama_barang,
                //   hitung2,
                //   this.ppdetillist[index].nilai_dtl_pp
                // );
              }
            }
          }
          if (ment.values.is_item == "no" && ment.values.used_for == "1") {
            if (ment.values.cur_type == "percentage") {
              let hitung3 = (totalprice * ment.values.harga) / 100;
              this.simulasibagiRataDiscountKeList(
                totalprice,
                hitung3,
                mode == "add" ? arr : this.listWO
              );
            } else {
              this.simulasibagiRataDiscountKeList(
                totalprice,
                ment.values.harga,
                mode == "add" ? arr : this.listWO
              );
            }
          }
          // if (ment.values.is_item == "no" && (ment.values.tax_type && ment.values.tax_type.includes("pph"))) {
          //   if (ment.values.cur_type == "percentage") {
          //     let hitung3 = (totalprice * ment.values.harga) / 100;
          //     this.simulasibagiRataDiscountKeList(
          //       totalprice,
          //       hitung3,
          //       mode == "add" ? arr : this.listWO
          //     );
          //   } else {
          //     this.simulasibagiRataDiscountKeList(
          //       totalprice,
          //       ment.values.harga,
          //       mode == "add" ? arr : this.listWO
          //     );
          //   }
          // }
        });

        this.ppdetillist.forEach((element) => {
          if (
            parseFloat(element.temp_nilai_dtl_pp) < 0 &&
            element.id_pp_dtl == poin.selectedPPdtl
          ) {
            result = false;
          }
        });

        let rcount = 0;
        arr.forEach((ment) => {
          if (ment.selectedPPdtl != "") {
            if (ment.values.is_item == "yes") {
              rcount = rcount + parseFloat(ment.values.hargaTotal);
            }
            if (ment.values.is_item == "no" && ment.values.used_for == "1") {
              rcount =
                (rcount+totalprice) -
                (ment.values.cur_type == "percentage"
                  ? (parseFloat(ment.values.harga) * totalprice) / 100
                  : parseFloat(ment.values.hargaTotal));
            }
            // if (ment.values.is_item == "no" && (ment.values.tax_type && ment.values.tax_type.includes("pph"))) {
            // rcount =
            //   rcount -
            //   (ment.values.cur_type == "percentage"
            //     ? (parseFloat(ment.values.harga) * totalprice) / 100
            //     : parseFloat(ment.values.hargaTotal));
            // }
            // if (ment.values.is_item == "no" && ment.values.used_for == "2" && !(ment.values.tax_type && ment.values.tax_type.includes("pph"))) {
              if (ment.values.is_item == "no" && ment.values.used_for == "2") {
              rcount =
                rcount +
                (ment.values.cur_type == "percentage"
                  ? (parseFloat(ment.values.harga) * totalpricedisc) / 100
                  : parseFloat(ment.values.hargaTotal));
            }
            if (
              ment.values.is_item == "no" &&
              ment.values.used_for !== "1" &&
              ment.values.used_for !== "2"
            ) {
              rcount =
                rcount +
                (ment.values.cur_type == "percentage"
                  ? (parseFloat(ment.values.harga) * totalprice) / 100
                  : parseFloat(ment.values.hargaTotal));
            }
            //console.log("result", rcount, ment.values.harga, totalpricedisc);
            if (rcount < 0) {
              result = false;
            }
          }
        });
      }
      return result;
    },
    recountingBalance(arr, mode) {
      if (this.ppdetillist.length > 0) {
        for (let index = 0; index < this.ppdetillist.length; index++) {
          this.ppdetillist[index].nilai_dtl_pp =
            this.ppdetillist[index].nilai_dtl_pp_origin;
        }
      }
      
      if (arr.length > 0) {
        //menghitung total jumlah item terbaru
        let totalprice = 0;
        arr.forEach((ent) => {
          if (ent.values.is_item == "yes") {
            totalprice += parseFloat(ent.values.hargaTotal);
          }
        });
        //menghitung diskon terbaru
        let totaldisc = 0;
        arr.forEach((ent) => {
          if (ent.values.is_item == "no" && ent.values.used_for == "1") {
            totaldisc +=
              ent.values.cur_type == "currency"
                ? parseFloat(ent.values.hargaTotal)
                : (parseFloat(ent.values.harga) * totalprice) / 100;
          }
          // if (ent.values.is_item == "no" && ent.values.tax_type && ent.values.tax_type.includes("pph")) {
          //   totaldisc +=
          //     ent.values.cur_type == "currency"
          //       ? parseFloat(ent.values.hargaTotal)
          //       : (parseFloat(ent.values.harga) * totalprice) / 100;
          // }
        });
        let totalpricedisc = totalprice - totaldisc;
        //short a to z
        arr.sort(function (a, b) {
          var x = a.key;
          var y = b.key;
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
        //console.log("short", arr);
        arr.forEach((ment) => {
          let ppdtl = ment.values.selectedPPdtl;
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem == ppdtl) {
              if (ment.values.cur_type == "percentage") {
                let hitung1 =
                  (parseFloat(ment.values.harga) *
                    // (ment.values.used_for == "2" && !ment.values.tax_type.includes("pph")
                    (ment.values.used_for == "2"
                      ? totalpricedisc
                      : totalprice)) /
                  100;
                this.ppdetillist[index].nilai_dtl_pp = (
                  parseFloat(this.ppdetillist[index].nilai_dtl_pp) - hitung1
                ).toString();
                // console.log(
                //   ment.key,
                //   index,
                //   "%kurangi",
                //   ment.values.pp_nama_barang,
                //   hitung1,
                //   this.ppdetillist[index].nilai_dtl_pp,
                //   parseFloat(ment.values.harga),
                //   mode,
                //   totalpricedisc,
                //   "=",
                //   totalprice,
                //   this.totalDiscList
                // );
              } else {
                let hitung2 = parseFloat(ment.values.hargaTotal);
                  this.ppdetillist[index].nilai_dtl_pp = (
                    parseFloat(this.ppdetillist[index].nilai_dtl_pp) - hitung2
                  ).toString();
                // console.log(
                //   ment.key,
                //   index,
                //   "kurangi",
                //   ment.values.pp_nama_barang,
                //   hitung2,
                //   this.ppdetillist[index].nilai_dtl_pp
                // );
              }
            }
          }

          if (ment.values.is_item == "no" && ment.values.used_for == "1") {
            if (ment.values.cur_type == "percentage") {
              let hitung3 = (totalprice * ment.values.harga) / 100;
              this.bagiRataDiscountKeList(
                totalprice,
                hitung3,
                mode == "add" ? arr : this.listWO
              );
            } else {
              this.bagiRataDiscountKeList(
                totalprice,
                ment.values.harga,
                mode == "add" ? arr : this.listWO
              );
            }
          }

          // if (ment.values.is_item == "no" && ment.values.tax_type && ment.values.tax_type.includes("pph")) {
          //   if (ment.values.cur_type == "percentage") {
          //     let hitung3 = (totalprice * ment.values.harga) / 100;
          //     this.bagiRataDiscountKeList(
          //       totalprice,
          //       hitung3,
          //       mode == "add" ? arr : this.listWO
          //     );
          //   } else {
          //     this.bagiRataDiscountKeList(
          //       totalprice,
          //       ment.values.harga,
          //       mode == "add" ? arr : this.listWO
          //     );
          //   }
          // }
        });

        for (let index = 0; index < this.listWO.length; index++) {
          const element = this.listWO[index];
          if ("percentage" == element.values.cur_type) {
            // if (element.values.used_for == "2"  && !element.values.tax_type.includes("pph")) {
              if (element.values.used_for == "2") {
              this.listWO[index].values.hargaTotal =
                (totalpricedisc * this.listWO[index].values.harga) / 100;
            } else {
              this.listWO[index].values.hargaTotal =
                (totalprice * this.listWO[index].values.harga) / 100;
            }
          }
        }

        //menghitung pajak, shipping dan etc
        // arr.forEach(ment => {
        //   let ppdtl=ment.values.selectedPPdtl
        //   for (let index = 0; index < this.ppdetillist.length; index++) {
        //     const elem = this.ppdetillist[index].id_pp_dtl;
        //     if (elem==ppdtl && ment.values.used_for=="2"){
        //       if(ment.values.cur_type=="percentage"){
        //         this.ppdetillist[index].nilai_dtl_pp = (parseFloat(this.ppdetillist[index].nilai_dtl_pp) -
        //           (parseFloat(ment.values.harga)*(totalprice)/100)).toString()
        //       }else{
        //         this.ppdetillist[index].nilai_dtl_pp = (parseFloat(this.ppdetillist[index].nilai_dtl_pp) -
        //           parseFloat(ment.values.hargaTotal)).toString()
        //       }
        //     }
        //   }
        // });
      }
    },
    simulasibagiRataDiscountKeList(total, val, arr) {
      //console.log("bagiRataDiscountKeList",total,val,arr)
      arr.forEach((ment) => {
        let ppdtl = ment.values.selectedPPdtl;
        for (let index = 0; index < this.ppdetillist.length; index++) {
          const elem = this.ppdetillist[index].id_pp_dtl;
          if (elem == ppdtl && ment.values.is_item == "yes") {
            this.ppdetillist[index].temp_nilai_dtl_pp =
              parseFloat(this.ppdetillist[index].temp_nilai_dtl_pp) +
              (parseFloat(ment.values.hargaTotal) / total) * val;
            // console.log(
            //   ment.key,
            //   index,
            //   "     - = ",
            //   this.ppdetillist[index].nilai_dtl_pp_origin,
            //   ment.values.hargaTotal,
            //   total,
            //   val,
            //   (parseFloat(ment.values.hargaTotal) / total) * val,
            //   this.ppdetillist[index].temp_nilai_dtl_pp
            // );
          }
        }
      });
    },
    bagiRataDiscountKeList(total, val, arr) {
      //console.log("bagiRataDiscountKeList",total,val,arr)
      arr.forEach((ment) => {
        let ppdtl = ment.values.selectedPPdtl;
        for (let index = 0; index < this.ppdetillist.length; index++) {
          const elem = this.ppdetillist[index].id_pp_dtl;
          if (elem == ppdtl && ment.values.is_item == "yes") {
            this.ppdetillist[index].nilai_dtl_pp =
              parseFloat(this.ppdetillist[index].nilai_dtl_pp) +
              (parseFloat(ment.values.hargaTotal) / total) * val;
            // console.log(
            //   ment.key,
            //   index,
            //   "     - = ",
            //   this.ppdetillist[index].nilai_dtl_pp_origin,
            //   ment.values.hargaTotal,
            //   total,
            //   val,
            //   (parseFloat(ment.values.hargaTotal) / total) * val,
            //   this.ppdetillist[index].nilai_dtl_pp
            // );
          }
        }
      });
    },
    kurangRataDiscountKeList(total, val) {
      this.getCountWeb.forEach((ment) => {
        let ppdtl = ment.values.selectedPPdtl;
        for (let index = 0; index < this.ppdetillist.length; index++) {
          const elem = this.ppdetillist[index].id_pp_dtl;
          if (elem == ppdtl && ment.values.used_for == null) {
            // console.log(
            //   "kurangRataDiscountKeList",
            //   this.ppdetillist[index].nilai_dtl_pp
            // );
            //this.ppdetillist[index].nilai_dtl_pp = parseFloat(this.ppdetillist[index].nilai_dtl_pp) - hasil
            this.ppdetillist[index].nilai_dtl_pp =
              parseFloat(this.ppdetillist[index].nilai_dtl_pp) -
              (parseFloat(ment.values.hargaTotal) * val) / total;
            break;
          }
        }
      });
    },
    handleClose() {
      this.recountingBalance(this.listWO, "remove");
      // this.trigered.used_for = false;
      // this.trigered.pn = true;
      // this.trigered.cur = false;
      // this.trigered.qty_unit = true;
      // this.trigered.is_item = "yes";
      // this.trigered.percentage = false;
      // this.trigered.disc = false;
      this.editData = [];
      this.resetForm();
    },
    handleOption(val) {
      if (val == "percentage") {
        this.trigered.percentage = true;
      } else {
        this.trigered.percentage = false;
      }

      let vinput = this.form.getFieldsValue();
      let tot = 0;
      tot =
        (vinput.jumlah ? vinput.jumlah : 1) *
        (vinput.harga ? vinput.harga : 0) *
        parseFloat(this.kurs);
      if (vinput.is_item == "no") {
        if (val == "percentage") {
          if (vinput.used_for == "3" || vinput.used_for == "4") {
            tot =
              ((this.totalPrice * vinput.harga) / 100) * parseFloat(this.kurs);
          } else {
            tot =
              (((this.totalPrice - this.totalDiscList) * vinput.harga) / 100) *
              parseFloat(this.kurs);
          }
        }
      }
      this.convert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    handleOptionmodal(val) {
      //console.log(val)
      let vinput = this.modalForm.getFieldsValue();
      let tot = 0;
      tot =
        (vinput.jumlah ? vinput.jumlah : 1) *
        (vinput.harga ? vinput.harga : 0) *
        parseFloat(this.kurs);
      if (vinput.is_item == "no") {
        if (val == "percentage") {
          let totdisc = vinput.used_for == "1" ? 0 : this.totalDiscList;
          if (
            vinput.used_for == "1" ||
            vinput.used_for == "3" ||
            vinput.used_for == "4"
          ) {
            totdisc = 0;
          }
          tot =
            (((this.totalPrice - totdisc) * vinput.harga) / 100) *
            parseFloat(this.kurs);
        }
      }
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    handleUseFor(val) {
      if (val.target.value == "1") {
        this.trigered.disc = true;
      } else {
        this.trigered.disc = false;
      }

      if (val.target.value == "2") {
        this.trigered.tax = true;
      }else{
        this.trigered.tax = false;
      }

      if(val.target.value == "4"){
        this.trigered.dis_tax_type=true;
      }else{
        this.trigered.dis_tax_type=false;
      }
      this.trigered.option=false;
    },
    fetchAttribute() {
      this.trigered.disabled = true;
      this.form.resetFields();
      let dataParams =
        this.mode == "Edit"
          ? {
              id_pp: this.data.id_pp,
              id_wo: this.data.id_wo,
            }
          : {
              id_pp: this.data.id_pp,
            };
      const ppdetil = axios({
        method: "get",
        params: dataParams,
        url: this.$serviceUrl + "pp/nama_item",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      return axios
        .all([
          ppdetil.catch((err) => {
            console.log(err);
            return null;
          }),
        ])
        .then((response) => {
          if (response[0] !== undefined) {
            this.ppdetillist = response[0].data.list_nama_item;
            if (this.listWO.length > 0) {
              this.recountingBalance(this.listWO, "remove");
            }
          } else {
            this.ppdetillist = [];
          }
          this.trigered.disabled = false;
        })
        .catch((err) => {
          this.trigered.disabled = false;
          console.log(err);
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
          // this.pageLoading = false;
        });
    },
    handleis_item(val) {
      if (val.target.value == "no") {
        this.trigered.is_item = "no";
        this.trigered.used_for = true;
        this.trigered.pn = false;
        this.trigered.cur = true;
        this.trigered.qty_unit = false;
        this.push = [];
        this.trigered.tax = true;
      } else {
        this.trigered.is_item = "yes";
        this.trigered.used_for = false;
        this.trigered.pn = true;
        this.trigered.cur = false;
        this.trigered.qty_unit = true;
        this.trigered.tax = false;
      }
      this.convert_value = 0;
      this.trigered.option=false;
      this.trigered.disabledTaxBearer = true;
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
        file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
      if (extension) {
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          this.form.resetFields();

          this.trigered.is_item = "yes";
          this.trigered.used_for = false;
          this.trigered.pn = true;
          this.trigered.cur = false;
          this.trigered.qty_unit = true;
          this.convert_value = 0;
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
      return false;
    },
    handleRemoveList(file) {
      const index = this.push.indexOf(file);
      const newFileList = this.push.slice();
      newFileList.splice(index, 1);
      this.push = newFileList;
    },
    handleDownload() {
      axios({
        method: "get",
        url: this.$serviceUrl + "/main/download_template_wo?X-API-KEY=xxx",
        params: {
          id_lk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          window.open(this.$serviceUrl + response.data.url, "_blank");
        })
        .catch((err) => {
          console.log(err);
          this.displayMessage("error-emptyDocTemplate");
        });
    },
    handleSatuan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleRef() {
      if (this.listWO.length <= 0) {
        this.displayMessage("more-content");
      } else {
        Event.$emit("woData", {
          DetailWO: this.listWO,
          emptyValidator: this.getCountWeb.length,
          grandtotal: this.grandTotal,
        });
      }
    },
    handleSave() {
      if (this.listWO.length <= 0) {
        this.displayMessage("more-content");
      } else {
        Event.$emit("listWO", { listWO });
      }
    },
    handleNewItem() {
      if (this.push.length > 0) {
        if (this.listWO.length > 0) {
          this.$confirm({
            title: "Are you sure want to replace an Exist data?",
            okText: "Yes",
            cancelText: "No",
            onOk() {
              Event.$emit("responseConfirmAdd", true);
            },
            onCancel() {},
          });
        } else {
          this.processNewItem();
        }
      } else {
        this.processNewItem();
      }
    },
    processNewItem() {
      this.newLoading = true;
      if (this.push.length > 0) {
        this.formUpload.validateFields((err, val) => {
          if (err) {
            this.newLoading = false;
            return;
          }
          let formData = new FormData();
          formData.append("file_upload", val.file_transfer.file);

          // if (this.isObject(this.selectedPN)){
          //   this.selectedPN = this.selectedPN.item_pn;
          // }
          // formData.append("item_pn", this.selectedPN ? this.selectedPN : "");

          axios({
            method: "post",
            url: this.$serviceUrl + "wo/upload_wo",
            processData: false,
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
              "Content-Type": "multipart/form-data",
            },
          })
            .then((response) => {
              Event.$emit("emptylistPekerjaan", true);
              let data = response.data.param;
              data.forEach((values) => {
                let hargaTotal = values.jumlah * values.harga;
                values.hargaTotal = values.jumlah * values.harga;
                values.is_item = "yes";
                values.used_for = null;
                values.cur_type = null;
                values.used_for = "0"
                Event.$emit("listWO", { key: "other", values, hargaTotal });
              });

              this.form.resetFields();
              //this.selectedPN = undefined;
              this.displayMessage("success-add");
              this.newLoading = false;
              this.push = [];
              this.resetForm();
            })
            .catch((err) => {
              let responses = Object.assign({}, err.response);
              if (responses.data) {
                this.displayMessageValue("error-other", responses.data.message);
              } else {
                this.displayMessageValue("error", responses);
              }
              this.newLoading = false;
              this.push = [];
            });
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            this.newLoading = false;
            return;
          }
          if (values.is_item == "no") {
            if (
              values.cur_type == "percentage" &&
              (this.getCountWeb.length == undefined ||
                this.getCountWeb.length == 0)
            ) {
              this.newLoading = false;
              this.displayMessage("empty-phurcaselist");
              this.newLoading = false;
              return;
            }
          }

          if (values.is_item == "yes") {
            let ddisc = _.filter(
                this.listWO,
                (obj) =>
                  obj.values.used_for== "1"
              );
            if(ddisc.length>0){
              this.newLoading = false;
              this.displayMessageValue("basic-error","Remove the discount first before add new item!");
              return;
            }
          }
          //console.log("1");
          //validasi value entri
          let plafon = 0;
          let pp_nama_barang = "";
          let pp_kode_anggaran = "";
          let vmsk = 0;
          if (values.is_item == "yes") {
            vmsk = values.jumlah * values.harga;
          } else {
            vmsk =
              values.cur_type == "percentage"
                ? (values.harga * this.totalPrice) / 100
                : values.harga;
          }
          //console.log("2");
          if (values.used_for == "1") {
            plafon = this.totalPrice;
          // } else if(values.tax_type && values.tax_type.includes("pph")){
          //   plafon = this.totalPrice;
          }else {
            this.ppdetillist.forEach((element) => {
              if (element.id_pp_dtl == values.selectedPPdtl) {
                plafon = parseFloat(element.nilai_dtl_pp);
                pp_nama_barang = element.nama_barang;
                pp_kode_anggaran = element.kode_anggaran;
              }
            });
          }

          //perilaku pajak jika PPH dkk disamakan dengan diskon 
          if(values.used_for == "2" && values.tax_type!="ppn" && values.tax_type!="bea_masuk"){
            plafon = this.totalPrice;
          }
          //console.log("3");
          //validasi pajak : tidak boleh lebih dari total
          if (
            // values.used_for == "2" && !(values.tax_type && values.tax_type.includes("pph")) &&
            values.used_for == "2" && !(values.tax_type && values.tax_type.includes("pph")) &&
            (vmsk > this.totalPrice - this.totalDiscList || vmsk > plafon)
          ) {
            this.newLoading = false;
            this.displayMessageValue("basic-error","Tax value cannot exceed 100% of PO value");
            return;
          }
          //validasi discount : tidak boleh lebih dari total
          if (
            values.used_for == "1" &&
            vmsk > this.totalPrice - this.totalDiscList
          ) {
            this.newLoading = false;
            this.displayMessageValue("basic-error","Discount value cannot exceed 100% of PO value");
            return;
          }
          //validasi PPH series : tidak boleh lebih dari total
          if (
            values.used_for == "2" && (values.tax_type && values.tax_type.includes("pph")) &&
            vmsk > this.totalPrice - this.totalDiscList
          ) {
            this.newLoading = false;
            this.displayMessageValue("basic-error","PPH Series value cannot exceed 100% of PO value");
            return;
          }
          //console.log("4");
          //validasi selain pajak : tidak boleh lebih dari plafon
          if (
            (vmsk - this.totalDiscList > plafon && values.used_for !== "1") ||
            (values.used_for == "1" && this.totalPrice - vmsk < 0) ||
            (values.used_for == "2" && (values.tax_type && values.tax_type.includes("pph")) && this.totalPrice - vmsk < 0)
          ) {
            this.newLoading = false;
            this.displayMessage("grather-remaining");
            return;
          }

          //console.log("5");
          if (this.isObject(this.selectedPN)) {
            this.selectedPN = this.selectedPN.item_pn;
          }

          values.item_pn = this.selectedPN ? this.selectedPN : "";
          if (values.item_pn == undefined) {
            values.item_pn = null;
          }
          if (values.cur_type == undefined) {
            values.cur_type = null;
          }
          if (values.used_for == undefined) {
            values.used_for = "0";
          }
          let findName = null;
          //console.log("6");
          if (values.used_for !== "1") {
            // console.log("6a.");
            if(values.used_for == "2" && values.tax_type!="ppn" && values.tax_type!="bea_masuk"){
                findName = _.filter(
                this.listWO,
                (obj) =>
                  obj.used_for !== "1" &&
                  obj.item_name &&
                  obj.item_name.toLowerCase() == values.item_name.toLowerCase()
              );
            }else{
              findName = _.filter(
                this.listWO,
                (obj) =>
                  obj.selectedPPdtl &&
                  obj.selectedPPdtl.toLowerCase() ==
                    values.selectedPPdtl.toLowerCase() &&
                  obj.item_name &&
                  obj.item_name.toLowerCase() == values.item_name.toLowerCase()
              );
            }
            // console.log("6a");
          } else {
            // console.log("6b.", this.getListDisc, values);
              if (values.tax_type && values.tax_type.includes("pph")){
              findName = _.filter(
                this.getListTax,
                (obj) =>
                  obj.item_name &&
                  obj.item_name.toLowerCase() == values.item_name.toLowerCase() &&
                  obj.values.tax_type &&
                  obj.values.tax_type == values.tax_type
              );
            }else{
              findName = _.filter(
                this.getListDisc,
                (obj) =>
                  obj.item_name &&
                  obj.item_name.toLowerCase() == values.item_name.toLowerCase()
              );
            }
            // console.log("6b");
          }

          if (findName && findName.length > 0) {
            this.displayMessage("form-duplicate");
            this.newLoading = false;
            return;
          } else {
            values.pp_nama_barang = pp_nama_barang;
            values.pp_kode_anggaran = pp_kode_anggaran;
            let hargaTotal = 0;
            if (values.is_item == "yes") {
              hargaTotal = values.jumlah * values.harga;
            } else {
              //  console.log("8");
              let valh = values.harga;
              hargaTotal =
                values.cur_type == "percentage"
                  ? (valh *
                      (this.totalPrice
                        ? this.totalPrice -
                          // (values.used_for == "2" && !(values.tax_type && values.tax_type.includes("pph")) ? this.totalDiscList : 0)
                          (values.used_for == "2" ? this.totalDiscList : 0)
                        : 0)) /
                    100
                  : valh;
            }
            values.hargaTotal = hargaTotal;

            let isthis = [
              ...this.listWO,
              JSON.parse(JSON.stringify({ key: "other", values })),
            ];
            if (this.simulation(isthis, values, "add") == false) {
              this.displayMessage("grather-remaining");
              this.newLoading = false;
              return;
            }

            Event.$emit("listWO", { key: "other", values });

            this.form.resetFields();
            this.trigered.is_item = "yes";
            this.trigered.used_for = false;
            this.trigered.qty_unit = true;
            this.trigered.cur = false;
            this.selectedPN = undefined;
            this.trigered.pn = true;
            this.trigered.disc = false;
            this.convert_value = 0;
            this.displayMessage("success-add");
            this.newLoading = false;
            this.resetForm();
          }
        });
      }
    },
    handleRemove(item) {
      //console.log(item);
      const newPush = this.listWO.filter(
        (valu) =>
          valu.item_name.concat(
            valu.values.selectedPPdtl
              ? valu.values.selectedPPdtl
              : valu.values.used_for
          , valu.values.used_for) !==
          item.item_name.concat(
            item.selectedPPdtl ? item.selectedPPdtl : item.used_for
          , item.used_for)
      );

      if (newPush.length > 0) {
        let nextpush = newPush.filter((valu) => valu.values.is_item == "yes");
        let discpush = newPush.filter(
          (valu) => valu.values.is_item == "no" && valu.values.used_for == "1"
        );
        let pphpush = newPush.filter(
          // (valu) => valu.values.is_item == "no" && valu.values.used_for == "2" && (valu.values.tax_type && valu.values.tax_type.includes("pph"))
          (valu) => valu.values.is_item == "no" && valu.values.used_for == "2"
        );
        if (nextpush.length == 0 && discpush.length > 0) {
          this.displayMessageValue(
            "error-other",
            "Work Order List Can't be empty, please delete all discount!"
          );
          this.newLoading = false;
          return;
        }
        if (nextpush.length == 0 && pphpush.length > 0) {
          this.displayMessageValue(
            "error-other",
            "Work Order List Can't be empty, please delete all PPH Series!"
          );
          this.newLoading = false;
          return;
        }
      }
    
      //jika list perhitungan existing dengan value baru menghasilkan nilai minus
      if (!this.simulation(newPush, "add")) {
        this.displayMessage("grather-remaining");
        this.newLoading = false;
        return;
      }

      let trig = false;
      if (item.used_for == "1" || (item.tax_type && item.tax_type.includes("pph"))) {
        for (let index = 0; index < this.ppdetillist.length; index++) {
          this.ppdetillist[index].temp_remove_val =
            this.ppdetillist[index].nilai_dtl_pp;
        }
        this.getCountWeb.forEach((ment) => {
          let ppdtl = ment.values.selectedPPdtl;
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem == ppdtl) {
              let bsaran =
                (ment.values.hargaTotal / this.totalPrice) * item.hargaTotal;
              //console.log("-",ment.values.hargaTotal,this.totalPrice,item.hargaTotal)
              //console.log(this.ppdetillist[index].temp_remove_val,bsaran,this.ppdetillist[index].temp_remove_val-bsaran)
              if ((parseFloat(this.ppdetillist[index].temp_remove_val)).toFixed(2) - bsaran.toFixed(2) < 0) {
                trig = true;
                return;
              }
              this.ppdetillist[index].temp_remove_val =
                this.ppdetillist[index].temp_remove_val - bsaran;
            }
          }
        });
      }
      if (trig) {
        this.displayMessage("grather-remaining");
        return;
      } else {
        this.confirmMessageValue("confirm-delete", item, null);
      }
    },
    delete(val) {
      //console.log(val)
      const newPush = this.listWO.filter(
        (item) =>
          item.item_name.concat(item.values.selectedPPdtl) !==
          val.item_name.concat(val.selectedPPdtl)
      );
      this.modalForm.resetFields();
      this.$nextTick(function () {
        this.form.setFieldsValue({
          is_item: "yes",
        });
      });
      this.trigered.is_item = "yes";
      this.trigered.used_for = false;
      this.trigered.qty_unit = true;
      this.trigered.cur = false;
      this.selectedPN = undefined;
      this.trigered.pn = true;
      this.trigered.disc = false;
      this.convert_value = 0;
      // const dataItem = item.toString();
      // const index = this.listWO.indexOf(item.toString());
      // const newPush = this.listWO.filter(
      //   (item) => item.values.item_name !== dataItem
      // );
      this.editData = [];
      Event.$emit("updateList", newPush);
    },
    handleEditModal(item) {
      //console.log(item)
      this.modalForm.resetFields();
      this.editData = item;
      this.editModal = !this.editModal;
      this.trigered.is_item = item.values.is_item;
      this.trigered.disc = item.values.used_for == "1" ? true : false;
      this.trigered.tax = item.values.used_for == "2" ? true : false;
      // this.taxTypeChange(item.values.tax_type);
      // this.handleDetail2(item.selectedPPdtl);
      if((item.values.tax_bearer && item.values.tax_bearer=='0' && item.values.used_for!='1') || item.values.used_for=='4'){
        this.trigered.enablePPTaxBearer=true;
        this.trigered.dis_tax_type = true;
      }else{
        this.trigered.enablePPTaxBearer=false;
        this.trigered.dis_tax_type = false;
      }
      if(item.values.tax_type && item.values.tax_type.includes('pph')){
        this.trigered.option = true;
      }else{
        this.trigered.option = false;
      }

      this.modalconvert_value = this.formatRupiah(
        item.values.hargaTotal * parseFloat(this.kurs)
      );

      if (item.values.used_for == null) {
        this.kurangRataDiscountKeList(this.totalPrice, this.totalDiscList);
      }
      if (this.ppdetillist.length > 0) {
        for (let index = 0; index < this.ppdetillist.length; index++) {
          const elem = this.ppdetillist[index].id_pp_dtl;
          if (elem == item.selectedPPdtl) {
            this.ppdetillist[index].nilai_dtl_pp =
              parseFloat(this.ppdetillist[index].nilai_dtl_pp) +
              item.values.hargaTotal;
            break;
          }
        }
      }
    },
    handleModalEdit(id_key) {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if(values.used_for==undefined)
          values.used_for="0";

        if (values.is_item == "no") {
          if (
            values.cur_type == "percentage" &&
            (this.getCountWeb.length == undefined ||
              this.getCountWeb.length == 0)
          ) {
            this.newLoading = false;
            this.displayMessage("empty-phurcaselist");
            return;
          }
        }

        if (this.isObject(this.selectedPNm)) {
          this.selectedPNm = this.selectedPNm.item_pn;
        }

        let findNames = null;
        if (values.used_for == "1") {
          findNames = _.filter(
            this.listWO,
            (obj) =>
              obj.values.used_for &&
              obj.values.used_for.toLowerCase() ==
                values.used_for.toLowerCase() &&
              obj.item_name &&
              obj.item_name.toLowerCase() == values.item_name.toLowerCase()
          );
        } else {
          if(values.used_for == "2" && values.tax_type!="ppn" && values.tax_type!="bea_masuk"){
              findNames = _.filter(
              this.listWO,
              (obj) =>
                obj.used_for !== "1" &&
                obj.item_name &&
                obj.item_name.toLowerCase() == values.item_name.toLowerCase()
            );
          }else{
            findNames = _.filter(
              this.listWO,
              (obj) =>
                obj.selectedPPdtl &&
                obj.selectedPPdtl == values.selectedPPdtl &&
                obj.item_name &&
                obj.item_name.toLowerCase() == values.item_name.toLowerCase()
            );
          }
        }

        if (findNames.length > 0 && findNames[0].key !== id_key) {
          this.displayMessage("form-duplicate");
          return;
        } else {
          //validasi value entri
          let plafon = 0;
          let pp_nama_barang = "";
          let pp_kode_anggaran = "";
          let vmsk = 0;
          if (values.is_item == "yes") {
            vmsk = values.jumlah * values.harga;
          } else {
            vmsk =
              values.cur_type == "percentage"
                ? (values.harga * this.totalPrice) / 100
                : values.harga;
          }

          let dataExist = {};
          if (values.used_for == "1") {
            plafon = this.grandTotal;
          } else {
            this.ppdetillist.forEach((element) => {
              if (element.id_pp_dtl == values.selectedPPdtl) {
                plafon = parseFloat(element.nilai_dtl_pp);
                pp_nama_barang = element.nama_barang;
                pp_kode_anggaran = element.kode_anggaran;
              }
            });
          }

          //perilaku pajak jika PPH dkk disamakan dengan diskon 
          if(values.used_for == "2" && values.tax_type!="ppn" && values.tax_type!="bea_masuk"){
            plafon = this.grandTotal;
          }

          //get discount exist
          //console.log(this.listWO);
          dataExist = _.filter(
            this.listWO,
            (obj) => obj.key && obj.key == id_key && obj.values.used_for == "1"
          );

          let discExist = 0;
          if (dataExist.length > 0) {
            discExist = dataExist.values.hargaTotal;
          }

          //validasi pajak : tidak boleh lebih dari total
          //console.log("pajak",values,vmsk,plafon,this.totalPrice,this.totalDiscList,dataExist,discExist)
          if (
            values.used_for == "2" &&
            (vmsk > this.totalPrice - (this.totalDiscList - discExist) ||
              vmsk > plafon)
          ) {
            this.newLoading = false;
            this.displayMessage("grather-remaining");
            return;
          }
          //validasi discount : tidak boleh lebih dari total
          if (
            values.used_for == "1" &&
            vmsk > this.totalPrice - (this.totalDiscList - discExist)
          ) {
            this.newLoading = false;
            this.displayMessage("grather-remaining");
            return;
          }
          //validasi selain pajak dan discount : tidak boleh lebih dari plafon
          //console.log("validasi -",vmsk,plafon)
          if (
            values.used_for !== "2" &&
            values.used_for !== "1" &&
            vmsk > plafon
          ) {
            this.newLoading = false;
            this.displayMessage("grather-remaining");
            // this.$nextTick(function () {
            //   this.modalForm.setFieldsValue({
            //     harga: null,
            //   });
            // });
            return;
          }
          //console.log("values", values);
          // if (values.used_for=="1"){
          //   console.log("simulasiEditDiskon")
          //   let trig = this.simulasiEditDiskon(this.editData,values)
          //   if (!trig){
          //     this.displayMessage("grather-remaining");
          //     return
          //   }
          //   console.log("end simulasiEditDiskon")
          // }

          if (this.isObject(this.selectedPN)) {
            this.selectedPN = this.selectedPN.item_pn;
          }
          values.item_pn = this.selectedPNm;
          const newPush = this.listWO.filter((item) => item.key !== id_key);
          let hargaTotal = 0;
          if (values.is_item == "yes") {
            hargaTotal = values.jumlah * values.harga;
          } else {
            let valh = values.harga;
            if (values.used_for == "2") {
              hargaTotal =
                values.cur_type == "percentage"
                  ? (valh *
                      (this.totalPrice
                        ? this.totalPrice - this.totalDiscList
                        : 0)) /
                    100
                  : valh;
            } else {
              hargaTotal =
                values.cur_type == "percentage"
                  ? (valh * (this.totalPrice ? this.totalPrice : 0)) / 100
                  : valh;
            }
          }
          if (this.mode == "Edit" && this.editData.values.id_wo_dtl) {
            values.id_wo_dtl = this.editData.values.id_wo_dtl;
          }
          values.hargaTotal = hargaTotal;
          values.pp_nama_barang = pp_nama_barang;
          values.pp_kode_anggaran = pp_kode_anggaran;

          let isthis = [
            ...newPush,
            JSON.parse(JSON.stringify({ key: "other", values })),
          ];
          if (!this.simulation(isthis, values, "add")) {
            this.displayMessage("grather-remaining");
            this.newLoading = false;
            return;
          }

          Event.$emit("updateList", newPush);

          Event.$emit("listWO", {
            key: id_key,
            hargaTotal: values.hargaTotal,
            item_name: values.nama_barang,
            selectedPPdtl: values.selectedPPdtl,
            unit_price: values.harga,
            values: values,
          });
          this.editData = [];
          this.editModal = !this.editModal;
          this.modalconvert_value = 0;
          this.resetForm();
          this.displayMessageValue("update-item", values.item_name);
        }
      });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    filterOption(input, option) {
      //console.log(option)
      return (
        option.componentOptions.children[0].children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOptionGeneral(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    confirmAdd() {
      // this.trigEmptyList = true;
      this.processNewItem();
    },
    toTextTax(val){
      let textReturn = _.filter(
              this.getType_tax, (obj) => obj.value == val.values.tax_type);
      return textReturn.length > 0 ? textReturn[0].text : '';
    },
    taxTypeChange(val){
      if (val=="ppn" || val=="bea_masuk" || val=="pph_23"){
        this.trigered.dis_tax_type = true;
      }else{
        this.trigered.dis_tax_type = false;
      }

      if(val=="ppn" || val=="bea_masuk"){
        this.trigered.disabledTaxBearer=true;
        this.trigered.enablePPTaxBearer=true;
          this.$nextTick(function () {
          this.form.setFieldsValue({
            tax_bearer: '0',
          });
        });
      }else if(val=="pph_23"){
        this.trigered.disabledTaxBearer=false;
        this.trigered.enablePPTaxBearer=false;
          this.$nextTick(function () {
          this.form.setFieldsValue({
            tax_bearer: '0',
          });
        });
      }else{
        this.$nextTick(function () {
            this.form.setFieldsValue({
              tax_bearer: '1',
            });
          });
        this.trigered.disabledTaxBearer=false;
        // let sts = this.form.getFieldValue("tax_bearer");
        // if(sts=='0'){
        //   this.trigered.enablePPTaxBearer=false;
        //   this.trigered.dis_tax_type = false;
        // }else{
          this.trigered.enablePPTaxBearer=false;
          this.trigered.dis_tax_type = false;
        //}
      }

      if(val.includes('pph')){
        this.trigered.option = true;
      }else{
        this.trigered.option = false;
      }
    },
    taxTypeChange2(val){
      if ((val=="ppn") || val=="bea_masuk" || val=="pph_23"){
        this.trigered.dis_tax_type = true;
      }else{
        this.trigered.dis_tax_type = false;
      }

      if(val=="ppn" || val=="bea_masuk"){
        this.trigered.disabledTaxBearer=true;
        this.trigered.enablePPTaxBearer=true;
          this.$nextTick(function () {
          this.form.setFieldsValue({
            tax_bearer: '0',
          });
        });
      }else if(val=="pph_23"){
        this.trigered.disabledTaxBearer=false;
        this.trigered.enablePPTaxBearer=false;
          this.$nextTick(function () {
          this.form.setFieldsValue({
            tax_bearer: '0',
          });
        });
      }else{
        this.trigered.disabledTaxBearer=false;
        let sts = this.modalForm.getFieldValue("tax_bearer");
        if(sts=='0'){
          this.trigered.enablePPTaxBearer=true;
          this.trigered.dis_tax_type = true;
        }else{
          this.trigered.enablePPTaxBearer=false;
          this.trigered.dis_tax_type = false;
        }
      }
    },
    changeTaxBearer(val){
        if(val.target.value=='0'){
          this.trigered.enablePPTaxBearer=true;
          this.trigered.dis_tax_type = true;
        }else{
          this.trigered.enablePPTaxBearer=false;
          this.trigered.dis_tax_type = false;
        }
    }
  },
};
</script>

<style lang="less">
.footer-list {
  display: flex;
  justify-content: flex-end;
  .ant-row {
    width: 100%;
  }
}
.footer-light {
  font-size: medium;
}
.select-between {
  .ant-select-selection-selected-value {
    width: 100%;
  }
}

.option-between {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;

  &__left {
    width: 70%;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__right {
    width: 30%;
    overflow: hidden;
    position: relative;
    text-align: right;
    font-weight: bold;
  }
}
</style>